import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { Controller, Control } from "react-hook-form";
import { normalizeUrl } from "@/utils/urlUtils";

interface OpportunityLinkFieldProps {
  control: Control<any>;
  referenceOptions: string[];
  showHelperText?: boolean;
}

export const OpportunityLinkField: React.FC<OpportunityLinkFieldProps> = ({
  control,
  referenceOptions,
  showHelperText = false,
}) => {
  return (
    <FormControl fullWidth margin="normal">
      <InputLabel id="opportunity-link-label">
        {showHelperText
          ? "Opportunity Link (shown to users)"
          : "Opportunity Link"}
      </InputLabel>
      <Controller
        name="opportunity_link"
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            labelId="opportunity-link-label"
            label={
              showHelperText
                ? "Opportunity Link (shown to users)"
                : "Opportunity Link"
            }
            disabled={referenceOptions.length === 0}
            value={normalizeUrl(field.value) ?? ""}
          >
            <MenuItem value="">
              <em>(None - fall back to funder website)</em>
            </MenuItem>
            {referenceOptions.map((url) => (
              <MenuItem key={url} value={url}>
                {url}
              </MenuItem>
            ))}
          </Select>
        )}
      />
      {showHelperText && (
        <FormHelperText>
          {referenceOptions.length === 0
            ? "Add URLs to References field first"
            : "This link will be shown to users when viewing matches. If not selected, users will see the funder's website instead."}
        </FormHelperText>
      )}
    </FormControl>
  );
};
